
import './OutOfTen.css';
import React from "react";

function OutOfTen(props) {
    return (
            <div className="outOfTen">
                <p className="tenTitle"> {props.title} </p>
                <div className="circlesRow">
                    <div onClick={() => props.setSelectedRating(1)} className={props.selectedRating === 1 ? "tenCircle activeTenCircle" : "tenCircle"}></div>
                    <div onClick={() => props.setSelectedRating(2)} className={props.selectedRating === 2 ? "tenCircle activeTenCircle" : "tenCircle"}></div>
                    <div onClick={() => props.setSelectedRating(3)} className={props.selectedRating === 3 ? "tenCircle activeTenCircle" : "tenCircle"}></div>
                    <div onClick={() => props.setSelectedRating(4)} className={props.selectedRating === 4 ? "tenCircle activeTenCircle" : "tenCircle"}></div>
                    <div onClick={() => props.setSelectedRating(5)} className={props.selectedRating === 5 ? "tenCircle activeTenCircle" : "tenCircle"}></div>
                    <div onClick={() => props.setSelectedRating(6)} className={props.selectedRating === 6 ? "tenCircle activeTenCircle" : "tenCircle"}></div>
                    <div onClick={() => props.setSelectedRating(7)} className={props.selectedRating === 7 ? "tenCircle activeTenCircle" : "tenCircle"}></div>
                    <div onClick={() => props.setSelectedRating(8)} className={props.selectedRating === 8 ? "tenCircle activeTenCircle" : "tenCircle"}></div>
                    <div onClick={() => props.setSelectedRating(9)} className={props.selectedRating === 9 ? "tenCircle activeTenCircle" : "tenCircle"}></div>
                    <div onClick={() => props.setSelectedRating(10)} className={props.selectedRating === 10 ? "tenCircle activeTenCircle" : "tenCircle"}></div>
                </div>
                <div className="tenFooterText">
                    <p className="tenFooter tenFooterLeft"> {props.left} </p>
                    <p className="tenFooter tenFooterRight"> {props.right} </p>
                </div>
            </div>
    )
}

export default OutOfTen;